import { EmojiProvider, Emoji } from "react-apple-emojis"
import emojiData from "react-apple-emojis/src/data.json"
import { useEffect, useState } from "react";
import { BP } from "../../../util/constants/breakpoints";

export default function ProjectHero() {

    const smallestHeader = 24;
    const mobileHeaderEmojiWidth = 36;
    const desktopHeaderEmojiWidth = 52;
    const mobileSubHeaderEmojiWidth = 15;
    const desktopSubHeaderEmojiWidth = 22;

    const [headerEmojiWidth, setHeaderEmojiWidth] = useState(mobileHeaderEmojiWidth);
    const [subHeaderEmojiWidth, setSubHeaderEmojiWidth] = useState(mobileSubHeaderEmojiWidth);

    const onWindowWidthChange = () => {
        setHeaderEmojiWidth(getHeaderEmojiWidth())
        setSubHeaderEmojiWidth(getSubHeaderEmojiWidth())
    }

    const getHeaderEmojiWidth = () => {
        if(window.innerWidth < BP.xs) return smallestHeader;
        if(window.innerWidth < BP.sm) return mobileHeaderEmojiWidth 
        else return desktopHeaderEmojiWidth 
    }

    const getSubHeaderEmojiWidth = () => {
        if(window.innerWidth < BP.sm) return mobileSubHeaderEmojiWidth 
        else return desktopSubHeaderEmojiWidth 
    }

    useEffect(() => {
        setHeaderEmojiWidth(getHeaderEmojiWidth)
        setSubHeaderEmojiWidth(getSubHeaderEmojiWidth)
        window.addEventListener("resize", onWindowWidthChange)
        return () => window.removeEventListener("resize", onWindowWidthChange)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return(
        <>
            <div 
                className="
                    bg-body-bg-light 
                    dark:bg-body-bg-dark
                    w-screen 
                    h-screen
                    flex
                    flex-col
                    justify-center
                    items-center
                    gap-y-2.5
                    sm:gap-y-7
                "
            >
                <h2
                    className="
                        text-2xl
                        xs:text-3xl
                        sm:text-5xl
                        text-body-text-light
                        dark:text-body-text-dark
                        tracking-widest
                        font-bold

                        flex
                        items-center
                    "
                >
                    Check out my work!&nbsp;
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name="hammer" width={headerEmojiWidth}/>
                    </EmojiProvider>
                </h2>
                <h3
                    className="
                        text-sm
                        sm:text-xl
                        text-body-text-grey
                        tracking-wide

                        flex
                        items-center
                    "
                >
                    Scroll Down&nbsp;
                    <EmojiProvider data={emojiData}>
                        <Emoji className="inline" name="backhand-index-pointing-down" width={subHeaderEmojiWidth}/>
                    </EmojiProvider>
                </h3>
            </div>
        </>
    );
}